import CircleIcon from '@mui/icons-material/Circle';
import '../App.css';
import { StyleConstants, Styles } from '../Styles';

const GreyLightIcon = () => {
    return (
        <CircleIcon 
            sx={{
                fill: StyleConstants.offLightColor,
                ...Styles.light,
            }}
        />
    );
};

export default GreyLightIcon;